import { TxnState } from '@global/constants/verification';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

//DMAC:DISABLE_MODIFICATION_AFTER_COMPLETION i.e. This is a list of organizations that are not allowed to modify
//     the transaction after it is completed.

const listOfDMACOrgs: string[] = (import.meta.env.VITE_DISABLE_MODIFICATION_AFTER_COMPLETION || '')
  .split(',')
  .map((item: string) => item.trim());
export function useSpecialConditions() {
  const formData = useSelector((s: any) => s.formData);

  const { txnInfo = {}, orgInfo = {} } = formData ?? {};

  const isTxnStatusCompleted = useMemo(() => {
    return txnInfo.state === TxnState.COMPLETED;
  }, [txnInfo.state]);

  const isModificationAllowed = (options: any = {}) => {
    if (listOfDMACOrgs.includes(orgInfo.orgId)) {
      return isTxnStatusCompleted && options.markedAsSkip;
    } else {
      return false;
    }
  };

  const isTxnCompleted = () => {
    if (listOfDMACOrgs.includes(orgInfo.orgId)) {
      return isTxnStatusCompleted;
    } else {
      return false;
    }
  };

  return {
    envCondition: {
      isModificationAllowed,
      isTxnCompleted
    }
  };
}
